import React from 'react';
import '../Styles/PricingPlans.css';

const plans = [
  {
    name: 'Gold Plan',
    price: '₹49',
    duration: '/mo',
    features: [
      'Upto 2 devices',
      'Watch movies in HD quality',
      'Get 500000 tokens instantly',
      'Supports Dolby Atmos audio quality',
    ],
    button: 'Purchase Now',
    popular: false,
    comingSoon: false,
  },
  {
    name: 'Diamond Plan',
    price: '₹199',
    duration: '/mo',
    features: [
      'Upto 4 devices',
      'Get 1000000 tokens instantly',
      'Watch movies in HD + 4K',
      'Get 1 latest bollywood movie ticket',
      'Supports Dolby Atmos + Auro-3D audio quality'
     
    ],
    button: 'Purchase Now',
    popular: true,
    comingSoon: false,
  },
  {
    name: 'Platinum Plan',
    price: '₹499',
    duration: '/mo',
    features: [
      'Upto 8 devices',
      'Get 5000000 tokens instantly',
      'Watch movies in HD + 4K',
      'Get 2 latest bollywood + 1 hollywood movie ticket',
      'Supports better audio quality and experience',
    
    ],
    button: 'Coming Soon',
    popular: false,
    comingSoon: true,
  },
];

export default function PricingPlans() {
  return (
    <div className="pricing-container">
      <div className="pricing-header">
        <h1>Pricing Plans</h1>
        <p>Your Budget Will Barely Notice Us</p>
      </div>

      <div className="plans-wrapper">
        {plans.map((plan, index) => (
          <div key={index} className="plan-card">
            {plan.popular && <span className="popular-tag">Most Popular</span>}

            <h2>{plan.name}</h2>
            <div className="plan-price">
              {plan.price}
              <span>{plan.duration}</span>
            </div>

            <ul className="features-list">
              {plan.features.map((feature, i) => (
                <li key={i}>● {feature}</li>
              ))}
            </ul>

            <button
              className={`plan-button ${plan.comingSoon ? 'disabled' : ''
                }`}
              disabled={plan.comingSoon}
            >
              {plan.button}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
